<template>
  <div>
    <v-container fluid fill-height>
      <v-layout row wrap>
        <v-flex xs12>
          <form-cad-promocao
            @MensagemGravaSucesso="showSucesso($event)"
            @gravacaoOkpromocao="buscaPromocao"
            @getCadpromocao="getErroCadPromocao($event)"
            @fechaDialog="fechaDialog"
            :dialog="selDialog"
            :zeraCampos="zerar"
            :dados="promocao"
          ></form-cad-promocao>

          <v-card v-show="true" light class="Black--text" color="card">
            <v-card-title primary-title>
              <div class=".pa-1 text-md-left headline">Promoções</div>
            </v-card-title>

            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Pesquisar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn class="white--text" @click="novo()" color="sucesso">
                Nova
                <v-icon dark right>add</v-icon>
              </v-btn>
            </v-card-title>

            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="false"
                :search="search"
                rows-per-page-text="registros por página"
                no-data-text="Nenhum resultado encontrado!"
                no-results-text="Nenhum resultado encontrado!"
                class="elevation-1"
              >
                <template slot="headerCell" slot-scope="props">
                  <v-tooltip bottom>
                    <span slot="activator">{{ props.header.text }}</span>
                    <span>{{ props.header.text }}</span>
                  </v-tooltip>
                </template>
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.cod_produto }}</td>
                  <td class="text-xs-left">{{ props.item.desconto }} %</td>
                  <td class="text-xs-right">{{ props.item.validade }}</td>
                  <td class="text-xs-left">{{ diaSemana(props.item.dia_semana) }}</td>
                  <td class="text-xs-right">
                    <v-switch
                      color="sucesso"
                      :label="`${checkStatus(props.item.chk_ativo)}`"
                      @change="mudarStatus(props.item.id,props.item.chk_ativo)"
                      v-model="props.item.chk_ativo=='T'? true :false"
                      value
                    ></v-switch>
                  </td>

                  <td class="text-xs-center">
                    <v-btn color="black" @click="edit( props.item.id)" flat icon small>
                      <v-icon center>edit</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template
                  slot="pageText"
                  slot-scope="props"
                >de{{ props.pageStart }} até {{ props.pageStop }} de {{ props.itemsLength }}</template>
              </v-data-table>
            </v-flex>
          </v-card>
        </v-flex>

        <v-snackbar
          :timeout="5000"
          :color="sucesso"
          :top="true"
          :multi-line="'multi-line'"
          :vertical="'vertical'"
          v-model="snackbarSuccess"
        >
          {{textSucesso}}
          <v-btn dark flat @click.native="snackbarSuccess = false">Fechar</v-btn>
        </v-snackbar>
        <v-snackbar
          :timeout="6000"
          :color="error"
          :top="true"
          :vertical="'vertical'"
          v-model="snackbar"
        >
          {{ textSnack }}
          <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
        </v-snackbar>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";
const FormCadPromocao = () => import("@/components/FormCadPromocao");

var moment = require("moment");

export default {
  mixins: [formata],

  data: () => ({
    snackbarSuccess: false,
    snackSucesso: "",
    textSucesso: "",
    textSnack: "",
    snackbar: false,
    error: "error",
    sucesso: "sucesso",
    menu: false,
    selDialog: false,
    zerar: false,
    dataIn: moment().format("YYYY-MM-01"),
    promocao: [],
    search: "",
    dataInFormatted: moment().format("01/MM/YYYY"),
    menu: false,
    menu2: false,
    dataFim: moment().format("YYYY-MM-DD"),
    dataFimFormatted: moment().format("DD/MM/YYYY"),
    // idFranquia: localStorage.getItem("tituloApp"),

    headers: [
      {
        text: "Código Produto",
        sortable: true,
        align: "left",
        value: "cod_produto"
      },
      {
        text: "Desconto",
        align: "left",
        value: "desconto"
      },
      {
        text: "Validade",
        align: "right",
        value: "validade"
      },
      {
        text: "Dia da Semana",
        align: "left",
        value: "dia_semana"
      },
      {
        text: "Status",
        align: "left",
        value: "chk_ativo"
      },
      {
        text: "Ações",
        value: "operacao",
        align: "center",
        sortable: false
      }
    ],
    items: []
  }),
  components: {
    FormCadPromocao
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.dataIn);
    }
  },
  watch: {
    dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
    }
  },
  mounted() {
    this.buscaPromocao();
  },
  methods: {
    diaSemana(val) {
      let dia;
      switch (val) {
        case 0:
          dia = "Todos";
          break;
        case 1:
          dia = "Domingo";
          break;
        case 2:
          dia = "Segunda-Feira";
          break;
        case 3:
          dia = "Terça-Feira";
          break;
        case 4:
          dia = "Quarta-Feira";
          break;
        case 5:
          dia = "Quinta-Feira";
          break;
        case 6:
          dia = "Sexta";
          break;
        case 7:
          dia = "Sábado";
          break;
      }
      return dia;
    },
    showSucesso(texto) {
      this.textSucesso = texto;
      this.snackbarSuccess = true;
    },
    edit(id) {
      this.zerar = "editar";

      return HTTP.get(`promocao/` + id).then(response => {
        console.log(response.data);
        this.promocao = response.data;
        this.selDialog = true;
        this.dialog = true;
        this.alterar = "Alterar";
      });
    },
    novo() {
      this.promocao = "";
      this.zerar = "novo";
      this.selDialog = true;
    },
    fechaDialog() {
      this.selDialog = false;
    },
    getErroCadPromocao(texto) {
      this.textSnack = texto;
      this.snackbar = true;
    },
    mudarStatus(id, status) {
      HTTP.patch(`promocao/` + id, { chk_ativo: status }).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbarSuccess = true;
        } else {
          this.snackbarSuccess = true;
          this.textSucesso = "Status alterado com sucesso.";
        }
        this.loading = false;
      });
    },
    checkStatus(valor) {
      if (valor == "T") {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },
    filtrar() {
      this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },
    buscaPromocao() {
      this.loading = true;
      HTTP.get(`promocao`).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          //this.extrato =

          this.items = response.data;
          this.mostraCartoes = true;
        }
        this.loading = false;
      });
    },

    //mudar para um mixed
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

<style>
#container {
  margin-top: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/Promocao.vue